import 'Plugins/videoPlugin';

export default function initVideo() {
    jQuery('[data-video]').bgVideo();
}